import React, {useState, useCallback, useEffect} from 'react';
import {Button, Modal, Input, Space, Table, message} from 'antd';
import {useNavigate, useSearchParams} from 'react-router-dom'

import JobFairApi from "../../api/jobfair";
import {filterJSON} from "../../util/transfer"
import CreateJobfairModal from "./create.modal";
import {toTime} from "../../util/time";
import config from "../../config";

export default function JobFairIndex() {
    let [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    let pageIndex = searchParams.get('pi') || 1
    let fairName = searchParams.get('fairName')
    let time = searchParams.get('t')

    const [list, setList] = useState([])
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [searchOptions, setSearchOptions] = useState({})

    useEffect(() => {
        loadData();
    }, [pageIndex, fairName, time])

    const doSearch = useCallback((options) => {
        options.t = Date.now()
        console.info(options)
        setSearchParams(filterJSON(options))
    })


    const loadData = useCallback((reset = false) => {
        if (loading) return;
        setLoading(true)

        JobFairApi.getPageList({
            pageIndex: reset ? 1 : pageIndex,
            name: fairName
        }).then(resp => {
            setLoading(false)
            setList(resp.list || [])
            setTotal(resp.totalCount)
        })

    })


    const columns = [

        {
            title: '名称',
            dataIndex: 'name',
            render: (name) => {
                return <span className="gray-dark bold">{name}</span>
            }
        },
        {
            title: '样式',
            width: 120,
            align: 'center',
            key: 'themeCode',
            render: (_, record) => {
                if (record.themeCode === 1) {
                    return <span className="fts-13 pdh20 pdv6 inline-block border border-radius green-bg white"
                    >样式一</span>
                } else {
                    return <span className="fts-13 pdh20 pdv6 inline-block border border-radius orange-bg white"
                    >样式二</span>
                }
            }
        }, {
            title: '创建时间',
            width: 120,
            align: 'center',
            key: 'createTime',
            render: (_, record) => (
                <span>{toTime(record.createTime)}</span>
            ),
        }, {
            title: '操作',
            key: 'action',
            align: 'center',
            render: (_, record) => (
                <Space wrap>
                    <Button type="link" onClick={() => review(record)}>PC预览</Button>
                    <Button type="link" onClick={() => review(record)}>WAP预览</Button>
                    <Button type="link" onClick={() => updateName(record)}>修改标题</Button>
                    <Button type="link" onClick={() => updatePage(record)}>编辑详情</Button>
                    <Button type="link" onClick={() => copyPage(record)}>复制</Button>
                    <Button type="link" onClick={() => deletePage(record)}>删除</Button>
                </Space>
            ),
        },
    ];

    const review = useCallback((record) => {
        window.open(config.PageUrl+'/xyzph/' + record.id)
    })

    const updateName = useCallback((record) => {
        setPageData(record)
        setIsModalShow(true)
    })

    const updatePage = useCallback(record => {
        navigate('/jobfair/' + record.id)
    })
    const copyPage = useCallback(record => {
        Modal.confirm({
            title: '确认复制？',
            content: record.name,
            okText: '是',
            cancelText: '否',
            onOk() {
                JobFairApi.copyJobFair({id: record.id}).then(resp => {
                    if (resp.resultCode === 1) {
                        message.success(resp.resultMessage)
                        loadData(true)
                    }
                })
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    })
    const deletePage = useCallback(record => {
        Modal.confirm({
            title: '确认删除？',
            content: record.name,
            okText: '是',
            type: 'danger',
            cancelText: '否',
            onOk() {
                JobFairApi.deleteJobFair({id: record.id}).then(resp => {
                    if (resp.resultCode === 1) {
                        message.success(resp.resultMessage)
                        loadData()
                    }
                })
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    })

    const onPagination = useCallback(function (index) {
        setSearchParams({...searchOptions, 'pi': index})
    })

    const [isModalShow, setIsModalShow] = useState(false)
    const [pageData, setPageData] = useState({})
    const newFairPage = useCallback(() => {
        setIsModalShow(true)
    })

    const onModalClose = useCallback((isUpdated) => {
        if (isUpdated) {
            loadData()
        }
        setPageData({})
        setIsModalShow(false)
    })


    return (
        <div style={{minWidth: 800, maxWidth: 1400}}>
            <SearchBar onSearch={doSearch} defaultValue={fairName}/>
            <div className="text-right mgb12">
                <Button type="primary" onClick={newFairPage}>新增宣传页面</Button>
            </div>
            <Table
                columns={columns}
                dataSource={list}
                rowKey="id"
                pagination={{
                    total: total,
                    current: parseInt(pageIndex),
                    pageSize: 10,
                    showSizeChanger: false,
                    onChange: onPagination
                }}
            />
            <CreateJobfairModal isShow={isModalShow} onClose={onModalClose} data={pageData}/>
        </div>
    );
};

function SearchBar({onSearch, defaultValue}) {
    const [fairName, setFairName] = useState(defaultValue)

    const resetOptions = useCallback(() => {
        setFairName()
    })

    const doSearch = useCallback(() => {
        onSearch && onSearch({
            fairName
        })
    })

    return (
        <div className="white-bg pdh16 pdv32 mgv12">
            <div className="flexbox wrap align-center mgb12">
                <div>
                    <span>招聘会名称：</span>
                    <Input
                        value={fairName}
                        onChange={(e) => setFairName(e.target.value)}
                        onPressEnter={doSearch}
                        placeholder="请输入" style={{width: 200, height: 32, marginRight: 32}}/>
                </div>
                <Space>
                    <Button type="primary" onClick={doSearch}>查询</Button>
                    <Button onClick={resetOptions}>重置</Button>
                </Space>
            </div>
        </div>
    )
}

